import "../../../../content/departments/express/express.css";
import * as React from 'react';
export default {
  React
};